// Этот файл генерируется автоматически, его не следует редактировать вручную
import createVueWidget from '@/core/createVueWidget.js';
import addToCart from '@/widgets/addToCart.vue';
import avalabFilter from '@/widgets/avalabFilter.js';
import blockSearch from '@/widgets/blockSearch.js';
import buyAllButton from '@/widgets/buyAllButton.vue';
import buyButton from '@/widgets/buyButton.vue';
import cartPage from '@/widgets/cartPage.vue';
import cartQuantity from '@/widgets/cartQuantity.vue';
import faqList from '@/widgets/faqList.js';
import filterBrands from '@/widgets/filterBrands.js';
import form from '@/widgets/form.js';
import globalEventButton from '@/widgets/globalEventButton.js';
import popupFilter from '@/widgets/popupFilter.js';
import popupForm from '@/widgets/popupForm.js';
import popupMenu from '@/widgets/popupMenu.js';
import popupMobileMenu from '@/widgets/popupMobileMenu.js';
import scrollTop from '@/widgets/scrollTop.js';
import selectedBrands from '@/widgets/selectedBrands.js';
import sliderArticles from '@/widgets/sliderArticles.js';
import sliderCategories from '@/widgets/sliderCategories.js';
import sliderMain from '@/widgets/sliderMain.js';

export default {
  'addToCart': async () => { return { default: (element, data) => createVueWidget(addToCart, element, data) }; },
  'avalabFilter': async () => { return { default: avalabFilter }; },
  'blockSearch': async () => { return { default: blockSearch }; },
  'buyAllButton': async () => { return { default: (element, data) => createVueWidget(buyAllButton, element, data) }; },
  'buyButton': async () => { return { default: (element, data) => createVueWidget(buyButton, element, data) }; },
  'cartPage': async () => { return { default: (element, data) => createVueWidget(cartPage, element, data) }; },
  'cartQuantity': async () => { return { default: (element, data) => createVueWidget(cartQuantity, element, data) }; },
  'collapse': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "secondary" */ '@/widgets/collapse.js'),
  'faqList': async () => { return { default: faqList }; },
  'filterBrands': async () => { return { default: filterBrands }; },
  'folder': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "secondary" */ '@/widgets/folder.js'),
  'form': async () => { return { default: form }; },
  'globalEventButton': async () => { return { default: globalEventButton }; },
  'headerSearch': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "secondary" */ '@/widgets/headerSearch.js'),
  'popupFilter': async () => { return { default: popupFilter }; },
  'popupForm': async () => { return { default: popupForm }; },
  'popupMenu': async () => { return { default: popupMenu }; },
  'popupMobileMenu': async () => { return { default: popupMobileMenu }; },
  'scrollTop': async () => { return { default: scrollTop }; },
  'selectedBrands': async () => { return { default: selectedBrands }; },
  'sliderArticles': async () => { return { default: sliderArticles }; },
  'sliderCategories': async () => { return { default: sliderCategories }; },
  'sliderMain': async () => { return { default: sliderMain }; },
  'switchTabsWithUrl': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "secondary" */ '@/widgets/switchTabsWithUrl.js'),
  'tabsSwitch': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "secondary" */ '@/widgets/tabsSwitch.js'),
  'telephoneMask': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "secondary" */ '@/widgets/telephoneMask.js')
};
